import { render } from "./dataStatistics.vue?vue&type=template&id=fce7f04c&scoped=true"
import script from "./dataStatistics.vue?vue&type=script&lang=js"
export * from "./dataStatistics.vue?vue&type=script&lang=js"

import "./dataStatistics.vue?vue&type=style&index=0&id=fce7f04c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce7f04c"]])

export default __exports__